const { clientCategories } = require('./constants');


export const getClientCategoryColor = category => {
  switch (category?.toUpperCase()) {
    case clientCategories.RETAIL:
      return 'primary';
    case clientCategories.CORPORATE:
      return 'secondary';
    default:
      return 'default';
  }
};